class StorageService {
  private prefix = 'sweco-source:'

  public get<T>(key: string): T | undefined {
    const raw = localStorage.getItem(this.generateKey(key))

    return raw ? (JSON.parse(raw) as T) : undefined
  }

  public set<T>(key: string, value: T): void {
    localStorage.setItem(this.generateKey(key), JSON.stringify(value))
  }

  public remove(key: string): void {
    localStorage.removeItem(this.generateKey(key))
  }

  private generateKey(key: string) {
    return `${this.prefix}${key}`
  }
}

export const storageService = new StorageService()
